import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const GenericRelationshipSchema = withDefaults({
  type: 'generic-relationship',
  fields: [
    {
      kind: 'attribute',
      name: 'relationshipType',
    },
    {
      kind: 'attribute',
      name: 'governableType',
    },
    {
      kind: 'attribute',
      name: 'governableId',
    },
    {
      kind: 'attribute',
      name: 'governorType',
    },
    {
      kind: 'attribute',
      name: 'governorId',
    },
    {
      kind: 'attribute',
      name: 'enum',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'updatedBy',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'expiresAfter',
    },
    {
      kind: 'belongsTo',
      name: 'delegateOf',
      type: 'generic-relationship',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'governor',
      type: 'generic-relationship',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default GenericRelationshipSchema;
